import { PGAdapterBuilder } from "@sia/style-guide";
import KeycloakIDPAdapter from "../IDPAdapter/KeycloakIDPAdapter";
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;


const pgAdapter = PGAdapterBuilder(KeycloakIDPAdapter, apiBaseUrl)
export default pgAdapter;
